import React from 'react';
import cacheRequests from './cacheRequests';

const _myVar = {};
_myVar.NODE_ENV = typeof env !== 'undefined' ? env.NODE_ENV : global.process.env.NODE_ENV;// eslint-disable-line no-undef
_myVar.PORT = typeof env !== 'undefined' ? env.PORT : global.process.env.PORT;// eslint-disable-line no-undef
const MY_VAR = typeof window !== 'undefined' ? window.env : (_myVar);

export default class DeleteCache extends React.Component {

  state = {}

  componentWillMount = () => {

  }

  componentDidMount = () => {
    const query = this.props.location.query;
    const key = query && query.key;
    const _t = key ? cacheRequests.deletecache(key, (response) => {
      this.setState({
        response,
      });
    }) : this.setState({
      response: {
        status: {
          error: 'Key parameter not added.',
        },
      },
    });
  }

  render() {
    return (
      <React.Fragment>
        <script dangerouslySetInnerHTML={{ __html: 'env = ' + (JSON.stringify(MY_VAR)) + '' }} />

        <div className="container">
          <div className="main"> Delete Cache
            {
              this.state.response && this.state.response.error &&
              <div className="error">
                {
                  this.state.response.error.status
                  &&
                  this.state.response.error.status.errorMessage}
              </div>
            }
            {
              this.state.response && this.state.response.data &&
              <div className="error">
                Cache entry deleted successfully.
              </div>
            }
          </div>
        </div>
      </React.Fragment >
    );
  }
}
